import { useEffect, useState } from "react";

import Card from "../../../../components/Card";
import Dropdown from "../../../../components/Dropdown";
import styles from "./Row.module.sass";
import tWallet from "../../../../i11/TokenWallet";
import TextInput from "../../../../components/TextInput";
import Icon from "../../../../components/Icon";
import Loader from "../../../../components/Loader";
import Modal from "../../../../components/Modal";
import Schedule from "../../../../components/Schedule";

import { useUser } from "../../../../context";
import { UseApi } from "../../../../hooks/use-api";
import { GetCollectionsSimple } from "../../../../Services/lib/nft";
import {
	GetCategoriesSimple,
	PatchListToToken,
} from "../../../../Services/lib/admin";
import { UseDisclosure } from "../../../../hooks/use-disclosure";
import { InputContValue } from "../../../../hooks/input-controller";
import { ToastEmitter } from "../../../../Services/assets/toast-emitter";
import Confirm from "../../../../components/Confirm";
import AmountField from "./AmountField";

const saleType = ["SALE", "AUCTION"];
const ListTokenStore = ({ item, onClose, getData }) => {
	const { locale } = useUser();

	const [sale, setSale] = useState(saleType[0]);
	const [categ, setCateg] = useState({
		val: "--/--",
		list: [
			{
				title: "--/--",
				_id: null,
			},
		],
	});
	const [coll, setColl] = useState({
		val: "--/--",
		list: [
			{
				name: "--/--",
				_id: null,
			},
		],
	});

	const [listBody, setBody] = useState({
		isOnSale: true,
		saleType: "SALE",
		_id: item._id,
		multiPrices: item?.multiPrices,
		// category: item.category?._id || null,
		// nftCollection: item.nftCollection?._id || null,
	});

	const [{ isLoading: colLoading }, getCollections] = UseApi({
		service: GetCollectionsSimple,
	});
	const [{ isLoading: catLoading }, getCategories] = UseApi({
		service: GetCategoriesSimple,
	});
	const [{ isLoading }, listToToken] = UseApi({
		service: PatchListToToken,
		successMsg: "Success",
	});

	const { onOpen, onClose: close, isOpen } = UseDisclosure();

	const handlerSubmit = async (e) => {
		e.preventDefault();
		if (sale !== saleType[0]) {
			ToastEmitter({
				msg: "Required Sale",
				type: "info",
			});
			return;
		}
		onOpen();
	};
	const init = async () => {
		const coll_ = await getCollections();
		if (coll_) {
			setColl((obj) => {
				return {
					val: item.nftCollection?.name || "--/--",
					list: [...obj.list, ...coll_],
				};
			});
		}
		const _cat = await getCategories();
		if (_cat) {
			setCateg((obj) => {
				return {
					val: item.category?.title || "--/--",
					list: [...obj.list, ..._cat],
				};
			});
		}
	};
	useEffect(() => {
		init();
	}, []);
	return (
		<Card
			title={tWallet[locale].modal_list_t_desc}
			classTitle="title-green"
		>
			<form onSubmit={handlerSubmit}>
				{catLoading || colLoading ? (
					<Loader className={styles.center} />
				) : (
					<>
						<Dropdown
							value={categ.val}
							options={categ.list.map((e) => e.title) || []}
							setValue={(e) => {
								InputContValue(setCateg, "val", e);
								const catID = categ.list.find(
									(cate) => cate.title === e
								);
								InputContValue(setBody, "category", catID._id);
							}}
							label={tWallet[locale].category}
						/>
						<br />
						<Dropdown
							value={coll.val}
							options={coll.list.map((e) => e.name) || []}
							setValue={(e) => {
								InputContValue(setColl, "val", e);
								const colID = coll.list.find(
									(cate) => cate.name === e
								);
								InputContValue(
									setBody,
									"nftCollection",
									colID._id
								);
							}}
							label={tWallet[locale].collection}
						/>
					</>
				)}
				<br />
				<Dropdown
					value={sale}
					options={saleType}
					setValue={setSale}
					dictionary={tWallet[locale].saleType}
					label={tWallet[locale].sale_type}
				/>
				<AmountField local={listBody} setLocal={setBody} />

				<br />
				<DateRow isSale={sale !== saleType[0]} setBody={setBody} />
				<div className={styles.right}>
					<button className="button" type="submit">
						{tWallet[locale].list}
					</button>
				</div>
			</form>
			<Modal visible={isOpen} onClose={close}>
				<Confirm
					title={tWallet[locale].confirm_list_q}
					onCancel={close}
					onConfirm={async () => {
						const res = await listToToken(listBody);
						if (res) {
							onClose();
							getData();
						}
					}}
					isLoading={isLoading}
				></Confirm>
			</Modal>
		</Card>
	);
};

const DateRow = ({ isSale, setBody }) => {
	const { locale } = useUser();
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");

	const {
		onOpen: startOpen,
		onClose: startClose,
		isOpen: startIsOpen,
	} = UseDisclosure();
	const {
		onOpen: endOpen,
		onClose: endClose,
		isOpen: endIsOpen,
	} = UseDisclosure();

	return (
		<>
			<div className={styles.fieldset}>
				<div
					className={styles.flexButton}
					style={{ width: isSale ? "50%" : "100%" }}
				>
					<div className={styles.field} onClick={startOpen}>
						<TextInput
							label={
								tWallet[locale][
									isSale ? "start_date" : "av_date"
								]
							}
							name="End date"
							type="text"
							value={startDate.toLocaleString()}
						/>
					</div>
					<button
						type="button"
						className="button button-stroke-red"
						onClick={() => {
							InputContValue(
								setBody,
								"secondaryPriceEndDate",
								""
							);
							setStartDate("");
						}}
					>
						<Icon name="trash" size="24" />
					</button>
				</div>
				{isSale && (
					<div className={styles.flexButton}>
						<div className={styles.field} onClick={endOpen}>
							<TextInput
								disabled={true}
								label={tWallet[locale].end_date}
								name="End date"
								type="text"
								value={endDate.toLocaleString()}
							/>
						</div>
						<button
							type="button"
							className="button button-stroke-red"
							onClick={() => setEndDate("")}
						>
							<Icon name="trash" size="24" />
						</button>
					</div>
				)}
			</div>

			<Modal visible={startIsOpen} onClose={startClose}>
				<Schedule
					onClick={startClose}
					startDate={startDate}
					setStartDate={(e) => {
						setStartDate(e);
						InputContValue(setBody, "secondaryPriceEndDate", e);
					}}
				/>
			</Modal>
			<Modal visible={endIsOpen} onClose={endClose}>
				<Schedule
					onClick={endClose}
					startDate={endDate}
					setStartDate={setEndDate}
				/>
			</Modal>
		</>
	);
};
export default ListTokenStore;
